import styled from 'styled-components';
import { defaultTheme } from 'styles/theme/default';

export const ConfirmContainer = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;

  .backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
  }

  .popup {
    position: relative;
    z-index: 1110;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    padding: 40px 32px 32px;
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;

    .closeIcon {
      position: absolute;
      top: 14px;
      right: 14px;
      font-size: 1.3rem;
      cursor: pointer;
      color: ${defaultTheme.colors['gray-200']};
      transition: color 0.15s;

      &:hover {
        color: ${defaultTheme.colors.black};
      }
    }

    h2 {
      font-family: 'Inter', sans-serif;
      font-size: 1.1rem;
      font-weight: 700;
      color: ${defaultTheme.colors.black};
      margin-bottom: 4px;
    }

    p {
      font-size: 0.95rem;
      color: ${defaultTheme.colors['gray-300']};
      line-height: 1.5;

      strong {
        color: ${defaultTheme.colors.black};
      }
    }

    .destinationSection {
      width: 100%;
      margin-top: 16px;
      text-align: left;

      > span {
        display: block;
        margin-bottom: 8px;
        color: ${defaultTheme.colors['gray-300']};
        font-size: 0.85rem;
        font-weight: 600;
      }

      .destinationOptions {
        display: flex;
        padding: 4px;
        border: 1px solid ${defaultTheme.colors['gray-100']};
        border-radius: 10px;
        background: ${defaultTheme.colors['white-box']};

        button {
          flex: 1;
          height: 34px;
          border: 0;
          border-radius: 8px;
          background: transparent;
          color: ${defaultTheme.colors['gray-300']};
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s;
        }

        button:hover {
          color: ${defaultTheme.colors.black};
        }

        button.selected {
          background: #fff;
        color: ${defaultTheme.colors['gray-300']};
          box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
          color: ${defaultTheme.colors.black};
        }
      }
    }

    .actions {
      display: flex;
      gap: 12px;
      margin-top: 24px;
      width: 100%;

    }
  }

  @media screen and (max-width: 820px) {
    .popup {
      max-width: 90%;
      padding: 32px 20px 24px;
    }
  }
`;
